var voted_users_default = {
  "container": "jHtie",
  "webview": "_0mEpa",
  "avatar_list": "o-J5O",
  "avatar": "OF6wX",
  "user_avatar": "NRnhQ",
  "modal": "RR754",
  "voted_users_modal": "vnwfp",
  "overlay": "an8Z4",
  "user_card": "_6BeTr",
  "user_name": "kcfyX",
  "voted_users_modal_header": "_8uLwJ",
  "cta": "f-VvK",
  "close_icon": "d5PmR",
  "title": "PnPVl",
  "member_list_container": "_3lkPU",
  "member_list": "VIncZ",
  "loader": "-rrZJ",
  "anonymous_counter": "U7PFO",
  "spinner": "_2chxI",
  "spin": "ISOum"
};
export {
  voted_users_default as default
};
//# sourceMappingURL=voted-users-scss.js.map
